import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { CalendarSubscriptionOutputType } from "@/TS/Zod";
export const useCalendarQueries = clubSlug => {
  const $ = _c(2);
  let t0;
  if ($[0] !== clubSlug) {
    t0 = {
      queryKey: ["calendar", clubSlug],
      queryFn: async () => {
        const response = await fetch(`/api/my-clubs/${clubSlug}/calendar/subscribe`);
        if (!response.ok) {
          throw new Error("Impossible de synchroniser l'agenda");
        }
        return await response.json();
      }
    };
    $[0] = clubSlug;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
};